<template>

    <div class="layout__container text__align-center">
        <h3 class="layout__padding-20-0">Unfortunately there's a problem with the Artwork</h3>

        <div class="layout__padding-20-0">
            <el-button
                    class="button-teal button__base text__align-center layout__width-200px"
                    v-on:click="upload()">
                Upload another file
            </el-button>

        </div>

        <div class="layout__padding-20-0">
            <p>Please contact our team who will be happy to review your template<br> and enable you to print
                with
                us.</p>
            <div class="layout__padding-20-0">
                <p>Ravensworth Client Services:</p>
                <p class="text__colour-teal">01865 712211</p>
                <p class="text__colour-teal">orders@printconcern.co.uk</p>
            </div>
        </div>

    </div>

</template>

<script>
    import Router from '../../../router';

    export default {
        name: "NoArtwork",
        components: {},
        data() {
            return {
                pdfArtowrk: ''
            }
        },
        created() {

            this.pdfArtowrk = window.sessionStorage.getItem('_filename')
        },
        methods: {
            upload() {
                Router.push({
                    name: '/instant-print',
                    params: {
                        printJob: this.printJob,
                        searchParams: this.searchParams
                    }
                });

                document.getElementById('pdfuploadDialog').click()
            }
        }
    };
</script>
